export default "__VITE_ASSET__BMP49LVg__"